// extracted by mini-css-extract-plugin
export default {"component_off":"ShowTopicCheckbox_component_off__wKKDD","component_on":"ShowTopicCheckbox_component_on__UzZgO"};